import { Component, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-page-content-wrapper',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss']
})

export class PageContentComponent implements OnDestroy {
  @Input() contentWidth;
  @Input() contentPadding;
  private readonly destroySubject$ = new Subject<boolean>();

  constructor() {}

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
